var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.077,
    height: 16.188,
    viewBox: "0 0 59.077 16.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iBook_Logo",
    "data-name": "iBook Logo",
    transform: "translate(-898.929 -569.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(898.929 569.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M898.929,571.329a1.815,1.815,0,0,1,1.975-1.771,1.783,1.783,0,0,1,1.975,1.71,1.983,1.983,0,0,1-3.949.062Zm.387,3.3h3.176V585.58h-3.176Z",
    transform: "translate(-898.929 -569.558)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(905.667 571.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M928.549,584.271c0,2.464-1.954,3.889-5.7,3.889h-7.37V573.909h6.962c3.563,0,5.395,1.486,5.395,3.7a3.425,3.425,0,0,1-1.894,3.135A3.519,3.519,0,0,1,928.549,584.271Zm-9.792-7.878v3.359h3.277c1.608,0,2.484-.57,2.484-1.69s-.875-1.669-2.484-1.669Zm6.473,7.532c0-1.2-.916-1.771-2.626-1.771h-3.847v3.522H922.6C924.314,585.676,925.23,585.146,925.23,583.925Z",
    transform: "translate(-915.479 -573.909)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(920.203 574.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M954.4,587.235a2.779,2.779,0,0,0,2.809,3.033h2.532V592.8l-2.532.081v0c-3.481,0-6.026-2.341-6.026-5.639s2.545-5.639,6.026-5.639v-.008l2.532.086V584.2h-2.532A2.779,2.779,0,0,0,954.4,587.235Z",
    transform: "translate(-951.181 -581.588)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4",
    transform: "translate(945.995 570.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M1019.236,582.618l-1.527,1.506v2.789h-3.176V571.808h3.176v8.551l4.642-4.4h3.786l-4.56,4.642,4.967,6.311H1022.7Z",
    transform: "translate(-1014.533 -571.808)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(935.353 574.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M996.919,587.241c0,3.294-2.52,5.635-5.993,5.639v0l-2.532-.081v-2.528h2.532a3.046,3.046,0,0,0,.029-6.066h-2.532v-2.528l2.532-.081v0C994.415,581.622,996.919,583.955,996.919,587.241Z",
    transform: "translate(-988.394 -581.598)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(925.012 577.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M967.405,590.669h-3.8a.611.611,0,1,1,0-1.221h3.8a.611.611,0,1,1,0,1.221Z",
    transform: "translate(-962.994 -589.448)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(924.283 579.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M967.007,594.951h-5.194a.611.611,0,0,1,0-1.221h5.194a.611.611,0,1,1,0,1.221Z",
    transform: "translate(-961.202 -593.73)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8",
    "data-name": "Grupo 8",
    transform: "translate(925.012 581.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M967.405,599.234h-3.8a.611.611,0,1,1,0-1.221h3.8a.611.611,0,1,1,0,1.221Z",
    transform: "translate(-962.994 -598.013)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9",
    transform: "translate(933.672 581.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M988.676,599.234h-3.8a.611.611,0,1,1,0-1.221h3.8a.611.611,0,1,1,0,1.221Z",
    transform: "translate(-984.265 -598.013)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(933.009 579.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M988.44,594.951h-5.194a.611.611,0,1,1,0-1.221h5.194a.611.611,0,1,1,0,1.221Z",
    transform: "translate(-982.635 -593.73)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(933.672 577.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M988.676,590.669h-3.8a.611.611,0,1,1,0-1.221h3.8a.611.611,0,1,1,0,1.221Z",
    transform: "translate(-984.265 -589.448)",
    fill: "#f0f0f0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2f3f2c287ff9436903f9986bcc408f29.svg";
export { ForwardRef as ReactComponent };